import { render, staticRenderFns } from "./CustomerPerformanceReport.vue?vue&type=template&id=afa34bd8&scoped=true"
import script from "./CustomerPerformanceReport.vue?vue&type=script&lang=js"
export * from "./CustomerPerformanceReport.vue?vue&type=script&lang=js"
import style0 from "./CustomerPerformanceReport.vue?vue&type=style&index=0&id=afa34bd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa34bd8",
  null
  
)

export default component.exports